<template>
  <div
    class="d-flex-column justify-start align-start work_with_us_spacing avergae_salary"
  >
    <div
      class="d-flex-row space-between align-start gap-48 height-max-content lg-row-to-col"
    >
      <!-- LEFT -->
      <div class="d-flex-column justify-start align-start flex-5 gap-40">
        <div class="d-flex-column justify-start align-start gap-24">
          <label
            class="t-orange font-family-2 caps regular-l"
            style="letter-spacing: 2.24px"
            >{{ $t("work_with_us_2.average_salary_cap") }}</label
          >
          <h1 class="t-white font-family-1 title-h2 f-w-600">
            {{ $t("work_with_us_2.average_salary_title") }}
          </h1>
          <p class="t-grey font-family-2 regular-xxl" style="max-width: 65ch">
            {{ $t("work_with_us_2.average_salary_desc") }}
          </p>
        </div>

        <div class="d-flex-row justify-start height-max-content flex-wrap">
          <button
            v-for="season in seasons"
            :key="season"
            class="dark tab _plain b-radius-6 height-36 width-max-content white-space-no medium font-family-2 medium-l"
            :class="[selectedSeason === season.id && 'active_tab']"
            @click.stop="setSeason(season.id)"
          >
            {{ $t(season.title) }}
          </button>
        </div>

        <div class="d-flex-column justify-start align-start gap-0">
          <label class="t-white font-family-1 title-h4 f-w-600"
            >{{ hours }} {{ $t("work_with_us_2.hours") }}{{ " "
            }}<span
              class="medium-xl t-grey font-family-2 g-w-500"
              style="text-transform: lowercase"
              >/{{ " " }}{{ $t("app.day") }}</span
            ></label
          >
          <SalarySlider :initial-value="hours" @update:value="setHours" />
        </div>
      </div>

      <!-- RIGHT -->

      <div
        class="d-flex-column flex-5 average_salary_calc align-end justify-end b-radius-32"
      >
        <img
          src="/images/work-with-us/average_salary_image.webp"
          class="average_salary_image"
          alt="average_salary_image"
        />
        <div class="d-flex-column average_salary_cont b-radius-16 gap-0">
          <p class="t-white regular-xl font-family-2">
            {{ $t("work_with_us_2.salary_per_month") }}
          </p>
          <h2 class="t-orange font-family-1 title-h2" style="margin-top: 10px">
            ~${{ parseFloat(salary).toFixed(2) }}
          </h2>
          <p
            class="t-grey font-family-2 regular-xl text-center"
            style="margin-top: 8px"
          >
            {{ $t("work_with_us_2.average_salary") }}
          </p>

          <button
            class="primary filled xxl b-radius-9 height-48 regular-l t-black f-w-600 font-family-1"
            style="margin-top: 32px"
          >
            {{ $t("work_with_us.apply_now") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import SalarySlider from "./SalarySlider.vue";
// const salary = ref(500);

const hours = ref(1);
const selectedSeason = ref("high");
const setHours = (parsedHours) => {
  hours.value = parseInt(parsedHours);
};

const setSeason = (season) => {
  selectedSeason.value = season;
};

const seasons = ref([
  {
    id: "high",
    title: "work_with_us_2.high_season",
    multiplier: 5,
  },
  {
    id: "medium",
    title: "work_with_us_2.medium_season",
    multiplier: 2.5,
  },
  {
    id: "low",
    title: "work_with_us_2.low_season",
    multiplier: 1,
  },
]);

const salary = computed(() => {
  const season = seasons.value.find((ses) => ses.id === selectedSeason.value);
  const h = hours.value;

  if (!season) return 0;

  switch (season.id) {
    case "low":
      switch (h) {
        case 1:
          return 150;
        case 2:
          return 200;
        case 3:
          return 350;
        case 4:
          return 550;
        case 5:
          return 800;
        case 6:
          return 1000;
        case 8:
          return 1300;
        case 10:
          return 1700;
        default:
          return 0;
      }
    case "medium":
      switch (h) {
        case 1:
          return 225;
        case 2:
          return 300;
        case 3:
          return 525;
        case 4:
          return 825;
        case 5:
          return 1200;
        case 6:
          return 1500;
        case 8:
          return 1950;
        case 10:
          return 2550;
        default:
          return 0;
      }
    case "high":
      switch (h) {
        case 1:
          return 300;
        case 2:
          return 400;
        case 3:
          return 700;
        case 4:
          return 1100;
        case 5:
          return 1600;
        case 6:
          return 2000;
        case 8:
          return 2860;
        case 10:
          return 3740;
        default:
          return 0;
      }
    default:
      return 0;
  }
});
</script>

<style lang="scss" scoped>
.avergae_salary {
  .average_salary_calc {
    position: relative;
    max-width: 564px;
    border-radius: 32px;
    background: linear-gradient(
      180deg,
      rgba(18, 21, 23, 0.7) 0%,
      rgba(18, 21, 23, 0) 100%
    );
    padding: 16px;
    min-height: 498px;
    .average_salary_image {
      position: absolute;
      width: 100%;
      height: auto;
      object-fit: contain;
      top: -15%;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .average_salary_cont {
      min-height: 282px;
      z-index: 99;
      background-color: var(--orange-dark);
      background-image: url(/images/work-with-us/salary_bg.webp);
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    }

    @media screen and (max-width: 900px) {
      margin-top: 40px;

      .average_salary_cont {
        min-height: max-content;
        padding: 32px 16px;
        padding-bottom: 43px;
      }
    }

    @media screen and (max-width: 600px) {
      min-height: 410px;
    }
  }
}
</style>
